import React from "react";

const MissionTerms = (props) => {
    const pdfLink =
        "../../../downloads/docs/202503-The-Conqueror-My-Virtual-Mission-Terms-of-Service.pdf";
    
    return (
        <React.Fragment>
            <h4>TERMS OF SERVICE</h4>
            <div className="form-check">
                <input
                    type="checkbox"
                    name="termsAccepted"
                    id="termsAccepted"
                    className="form-check-input"
                    checked={props.isChecked}
                    onChange={props.handleChange}
                />
                <label htmlFor="termsAccepted" className="">I agree to the My Virtual Mission {" "}
                    <a
                        href={pdfLink}
                        target="_blank"
                    >
                        Terms of Service.
                    </a>
                </label>
            </div>
        </React.Fragment>
    );
};

export default MissionTerms;
